import React from 'react';

const IconDashboard = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 18.9998V12.2668C21 11.7242 20.8896 11.1873 20.6756 10.6888C20.4616 10.1902 20.1483 9.74045 19.755 9.36677L13.378 3.30977C13.0063 2.95665 12.5132 2.75977 12.0005 2.75977C11.4878 2.75977 10.9947 2.95665 10.623 3.30977L4.245 9.36677C3.85165 9.74045 3.53844 10.1902 3.3244 10.6888C3.11037 11.1873 3 11.7242 3 12.2668V18.9998C3 19.5302 3.21071 20.0389 3.58579 20.414C3.96086 20.7891 4.46957 20.9998 5 20.9998H19C19.5304 20.9998 20.0391 20.7891 20.4142 20.414C20.7893 20.0389 21 19.5302 21 18.9998Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default IconDashboard;
